import { Map, fromJS } from 'immutable';

export function request(state, { sportId }) {
    return state
        .setIn('state', 'IN_PROGRESS')
        .setIn(['items', sportId], fromJS({}));
}

export function error(state, { sportId, errors }) {
    return state
        .setIn('state', 'ERROR')
        .setIn(['items', sportId, 'errors'], fromJS(errors));
}

export function finish(state, {sportId, prices}) {
    return state
        .setIn('state', 'FINISHED')
        .setIn(['items', sportId, 'prices'], fromJS(prices));
}
